import $ from "jquery";
import App from "../src/App";
import { Swiper } from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/scss";
import "swiper/scss/navigation";

$(".js-gallery").each(function () {
  const $gallery = $(this);
  const $swiperEl = $gallery.find(".swiper");

  // Initialize Swiper
  const swiper = new Swiper($swiperEl[0], {
    modules: [Navigation],
    slidesPerView: 1,
    autoplay: false,
    loop: true,
    speed: 1200,
    navigation: {
      prevEl: $gallery.find(".gallery__button--prev")[0],
      nextEl: $gallery.find(".gallery__button--next")[0],
    },
  });

  // Manually trigger initialization
  swiper.emit("init");
});

$(".js-anchors").each(function () {
  const $anchors = $(this);
  const $swiperEl = $anchors.find(".swiper");

  // Initialize Swiper
  const swiper = new Swiper($swiperEl[0], {
    slidesPerView: "auto",
    loop: false,
  });

  // Manually trigger initialization
  swiper.emit("init");

  // Handle active state for anchor links
  $anchors.on("click", ".anchor-links__item", function (e) {
    // Remove active class from all anchor links
    $(".anchor-links__item").removeClass("active");

    // Add active class to clicked anchor link
    $(this).addClass("active");
  });
});

// Handle read more/less functionality
$(".read-more-btn").on("click", function () {
  const container = $(this).closest(".description-container");
  container.find(".description-truncated").hide();
  container.find(".description-full").show();
});

$(".read-less-btn").on("click", function () {
  const container = $(this).closest(".description-container");
  container.find(".description-full").hide();
  container.find(".description-truncated").show();
});

// Load More functionality - per group with incremental loading
$(document).on("click", ".toggle-items-button", function () {
  const $button = $(this);
  const state = $button.data("state");
  const initialShow = $button.data("initial-show");
  const $group = $button.parent().parent().find(".amenities-group");
  const $itemsOfInterest = $group.slice(initialShow);

  if (state === "more") {
    $itemsOfInterest.removeClass("js-hidden-item");
    $button.text("Show Less").data("state", "less");
  } else {
    $itemsOfInterest.addClass("js-hidden-item");
    $button.text("Show More").data("state", "more");
  }
});
